// extracted by mini-css-extract-plugin
module.exports = {"container":"FrequentlyAskedQuestions_container__wDaMH","questions_container":"FrequentlyAskedQuestions_questions_container__hJ85B"};